import { clearProfileInfoData, setProfileInfoData, validateProfileInfoData } from './profile_info';
import { clearOtherInfoData, setOtherInfoData, validateOtherInfoData } from './other_info';
import { clearKycInfoData, setKycInfoData, validateKycInfoData } from '../kyc';
import { clearProfileAddressData, setProfileAddressData, validateAddressInfoData } from '../profile_address';
import { clearGloablMessage, setLoading, setGlobalMessage } from '../app';
import { ALERT_SEVERITY, ERROR_MESSAGES, VALIDATION_MESSAGES } from 'eebac/constants';
import ApiDataHelper from 'eebac/utils/apiDataHelper';
import VendorInfoFields from 'eebac/constants/fields/vendor/vendor_profile_info';
import AddressInfoFields from 'eebac/constants/fields/address';
import KycInfoFields from 'eebac/constants/fields/kyc';
import OtherInfoFields from 'eebac/constants/fields/vendor/other_info';
import { Catch } from '../api_exception';
import { setAvatar } from './avatar';
import { setUserBoxProfile } from '../userbox_profile';
import { ROUTES_PATH_CONFIG } from 'eebac/config/routes';
import { clearSecurityInfoData, setSecurityInfoData, validateSecurityInfoData } from '../security_info';


const BASE_PATH = "VENDOR_PROFILE";

const setProfileData = (dispatch, profileData) => {
    dispatch(setAvatar(profileData.avatar));
    dispatch(setUserBoxProfile(profileData.avatar,
        profileData.userName, profileData.score, ROUTES_PATH_CONFIG.VENDOR.profile,
        profileData.vendorInfoData.code))

    ApiDataHelper.set(
        (data) => dispatch(setProfileInfoData(data)),
        profileData.vendorInfoData,
        { ...VendorInfoFields, address: {} });

    ApiDataHelper.set(
        (data) => dispatch(setProfileAddressData(data)),
        profileData.addressInfoData,
        AddressInfoFields);

    // ApiDataHelper.set(
    //     (data) => dispatch(setKycInfoData(data)),
    //     profileData.kycInfoData,
    //     KycInfoFields);

    ApiDataHelper.set(
        (data) => dispatch(setOtherInfoData(data)),
        profileData.otherInfoData,
        OtherInfoFields);

    dispatch(setSecurityInfoData([{ key: "password", value: "" }]));
}

export const updateProfile = () =>
    (dispatch, getState, client) => {

        let state = getState();
        let profileAvatar = state.VENDOR_AVATAR_DATA.avatar;
        if (!profileAvatar) {
            dispatch(setGlobalMessage(VALIDATION_MESSAGES.PROFILE_PHOTO, ALERT_SEVERITY.ERROR));
            dispatch(setLoading(false));
            return;
        }

        dispatch(setLoading(true));
        let apiData = {
            avatar: profileAvatar,
            vendorInfoData: ApiDataHelper.get(state.VENDOR_PROFILE_INFO,
                VendorInfoFields),
            addressInfoData: ApiDataHelper.get(state.PROFILE_ADDRESS,
                AddressInfoFields),
            //kycInfoData: ApiDataHelper.get(state.VENDOR_KYC_DATA,
            //    KycInfoFields),
            otherInfoData: ApiDataHelper.get(state.VENDOR_OTHER_INFO,
                OtherInfoFields),
            securityInfoData: {
                password: state.SECURITY_INFO.password
            }
        }

        client.put('/vendor/profile', apiData)
            .then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess &&
                    result.data.profile) {
                    // if (state.VENDOR_PROFILE_SUBMIT.firstTimeUpdate) {
                    //    dispatch(isFirstUpdate(false));
                    dispatch(showUpdateRates(true));
                    // }

                    dispatch(setGlobalMessage(result.successMessage));
                    setProfileData(dispatch, result.data.profile);

                } else {
                    if (result.data.vendorInfoDataErrors &&
                        Array.isArray(result.data.vendorInfoDataErrors)) {
                        dispatch(setProfileInfoData(result.data.vendorInfoDataErrors))
                    }

                    if (result.data.addressInfoData &&
                        Array.isArray(result.data.addressInfoData)) {
                        dispatch(setProfileAddressData(result.data.addressInfoData))
                    }

                    // if (result.data.kycInfoDataErrors &&
                    //     Array.isArray(result.data.kycInfoDataErrors)) {
                    //     dispatch(setKycInfoData(result.data.kycInfoDataErrors))
                    // }

                    if (result.data.otherInfoDataErrors &&
                        Array.isArray(result.data.otherInfoDataErrors)) {
                        dispatch(setOtherInfoData(result.data.otherInfoDataErrors))
                    }

                    if (result.data.securityInfoDataErrors &&
                        Array.isArray(result.data.securityInfoDataErrors)) {
                        dispatch(setSecurityInfoData(result.data.securityInfoDataErrors))
                    }

                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const validateProfile = () =>
    (dispatch, getState, client) => {

        let state = getState();
        dispatch(setLoading(true));

        dispatch(validateProfileInfoData())
        dispatch(validateAddressInfoData());
        // dispatch(validateKycInfoData());
        dispatch(validateOtherInfoData());
        dispatch(validateSecurityInfoData());
    }


export const loadProfile = () =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        dispatch(clearProfileInfoData());
        dispatch(clearProfileAddressData());
        // dispatch(clearKycInfoData());
        dispatch(clearOtherInfoData());
        dispatch(clearSecurityInfoData());
        dispatch(setAvatar(""));

        client.get('/vendor/profile').
            then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess &&
                    result.data.profile) {

                    if (!result.data.profile.avatar) {
                        dispatch(isFirstUpdate(true));
                    } else {
                        dispatch(isFirstUpdate(false));
                    }

                    setProfileData(dispatch, result.data.profile);
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const loadPrintProfile = () =>
    (dispatch, getState, client) => {

        dispatch(setLoading(true));

        client.get(`/vendor/print/profile`).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.profile) {
                    dispatch(setPrintProfileData(result.data.profile));
                    dispatch(viewVendorProfile(true));
                } else {
                    dispatch(setPrintProfileData(null));
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                    dispatch(viewVendorProfile(false));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
                dispatch(setPrintProfileData(null));
            });
    }

export const PROFILE_FORM_SUBMIT = `${BASE_PATH}/PROFILE_FORM_SUBMIT`;
export const SET_VENDOR_PROFILE = `${BASE_PATH}/SET_VENDOR_PROFILE`;
export const VIEW_VENDOR_PROFILE = `${BASE_PATH}/VIEW_VENDOR_PROFILE`;
export const VIEW_VENDOR_PROFILE_CLOSE = `${BASE_PATH}/VIEW_VENDOR_PROFILE_CLOSE`;
export const IS_VENDOR_PROFILE_FIRST_TIME_UPDATE = `${BASE_PATH}/IS_VENDOR_PROFILE_FIRST_TIME_UPDATE`;
export const SHOW_UPDATE_RATES = `${BASE_PATH}/SHOW_UPDATE_RATES`;

export const setProfileFormSubmit = (isSubmit) => ({
    type: PROFILE_FORM_SUBMIT,
    isSubmit
});

export const setPrintProfileData = (data) => ({
    type: SET_VENDOR_PROFILE,
    data
});

export const viewVendorProfile = (open) => ({
    type: VIEW_VENDOR_PROFILE,
    open
});

export const closePrint = () => ({
    type: VIEW_VENDOR_PROFILE_CLOSE
});

export const isFirstUpdate = (flag) => ({
    type: IS_VENDOR_PROFILE_FIRST_TIME_UPDATE,
    flag
});

export const showUpdateRates = (flag) => ({
    type: SHOW_UPDATE_RATES,
    flag
});

const initialState = {
    isSubmit: false,
    profileData: "",
    printProfile: false,
    firstTimeUpdate: false,
    showUpdateRates: false
}

export function ProfileFormSubmitReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case PROFILE_FORM_SUBMIT:
            return { ...state, isSubmit: action.isSubmit };
        case SET_VENDOR_PROFILE:
            return {
                ...state,
                profileData: action.data
            }
        case VIEW_VENDOR_PROFILE:
            return { ...state, printProfile: action.open };
        case VIEW_VENDOR_PROFILE_CLOSE:
            return { ...state, printProfile: false };
        case IS_VENDOR_PROFILE_FIRST_TIME_UPDATE:
            return { ...state, firstTimeUpdate: action.flag };
        case SHOW_UPDATE_RATES:
            return { ...state, showUpdateRates: action.flag };
    }

    return state;
}